import { useEffect } from 'react';

/**
 * Hook to prevent the user from navigating away or closing the browser tab.
 * @param shouldPrevent - boolean indicating if navigation should be prevented
 */
export const usePreventNavigation = (shouldPrevent: boolean) => {
  useEffect(() => {
    if (!shouldPrevent) {
      return;
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Included for legacy support, e.g. Chrome/Edge < 119
      e.returnValue = true;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldPrevent]);
};
